import { PrescriptionType } from '@ca/common'
import Status from '@ui/elements/Status'
import { StatusVariant } from '@ui/elements/Status/types'
import { useTranslation } from 'react-i18next'

const prescriptionVariant: Record<PrescriptionType, StatusVariant> = {
  refbox: 'success',
  manual: 'warning',
  pd: 'danger',
  other: 'neutral',
  pdAdded: 'warning',
}

interface Props {
  type: PrescriptionType
  className?: string
}

export default function PrescriptionTypeBadge({ type, className }: Props) {
  const { t } = useTranslation(['status'])
  return (
    <Status
      variant={prescriptionVariant[type]}
      text={t(`status:prescription.${type}`)}
      className={className}
    />
  )
}
